export const GET_CHARACTERS_REQUEST = "GET_CHARACTERS_REQUEST";
export const GET_CHARACTERS_SUCCESS = "GET_CHARACTERS_SUCCESS";
export const GET_CHARACTERS_FAILURE = "GET_CHARACTERS_FAILURE";

export const GET_CHARACTER_REQUEST = "GET_CHARACTER_REQUEST";
export const GET_CHARACTER_SUCCESS = "GET_CHARACTER_SUCCESS";
export const GET_CHARACTER_FAILURE = "GET_CHARACTER_FAILURE";

export const GET_MOVIES_REQUEST = "GET_MOVIES_REQUEST";
export const GET_MOVIES_SUCCESS = "GET_MOVIES_SUCCESS";
export const GET_MOVIES_FAILURE = "GET_MOVIES_FAILURE";

export const GET_MOVIE_REQUEST = "GET_MOVIE_REQUEST";
export const GET_MOVIE_SUCCESS = "GET_MOVIE_SUCCESS";
export const GET_MOVIE_FAILURE = "GET_MOVIE_FAILURE";

export const GET_PLANET_REQUEST = "GET_PLANET_REQUEST";
export const GET_PLANET_SUCCESS = "GET_PLANET_SUCCESS";
export const GET_PLANET_FAILURE = "GET_PLANET_FAILURE";

export const GET_SPECIE_REQUEST = "GET_SPECIE_REQUEST";
export const GET_SPECIE_SUCCESS = "GET_SPECIE_SUCCESS";
export const GET_SPECIE_FAILURE = "GET_SPECIE_FAILURE";

export const GET_STARSHIP_REQUEST = "GET_STARSHIP_REQUEST";
export const GET_STARSHIP_SUCCESS = "GET_STARSHIP_SUCCESS";
export const GET_STARSHIP_FAILURE = "GET_STARSHIP_FAILURE";

export const GET_VEHICLE_REQUEST = "GET_VEHICLE_REQUEST";
export const GET_VEHICLE_SUCCESS = "GET_VEHICLE_SUCCESS";
export const GET_VEHICLE_FAILURE = "GET_VEHICLE_FAILURE";
